$(document).ready(function () {
  $('.swiper-recommendations').each(function () {
    if (!$(this).hasClass('swiper-already-initiated')) {
      $(this).addClass('swiper-already-initiated')
      const recommendedSwiper = new Swiper (this, {
        slidesPerView: 'auto',
        freeMode: true,
        loop: false,
        spaceBetween: 0,
        direction: 'horizontal',
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: '.swiper-recommended-next',
          prevEl: '.swiper-recommended-prev',
        },
      });
    }

  });

});
